/* eslint-disable react-hooks/exhaustive-deps */
import { useBoolean, useToast } from '@chakra-ui/react'
// import downloadCsv from 'download-csv'
import * as crypto from 'crypto-js'
import FileSaver from 'file-saver'
import { createContext, FC, useCallback, useMemo, useState } from 'react'
import { AiOutlineBarChart } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import { parseFollowUpOtbData } from '@helper/grid/otb/followUp'
import { parseFollowUpOtbFooterData } from '@helper/grid/otb/followUp-footer'
import { paramsFollowUpToSendMapping } from '@helper/otb/followUp/paramsToSendMapping'
import { validateGroupName } from '@helper/otb/followUp/validateGroupName'
import { validateIfShowColumnInTable } from '@helper/otb/followUp/validateIfShowColumnInTable'
import followUp from '@service/otb/followup'

import { ILayoutFilter } from '@base/@types/components/Layout/Filters'
import {
  ITableGridAction,
  ITableHeader
} from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  IFollowUpOtbContext,
  IParamsToSend,
  Pagination,
  ILineParams,
  IParseParamsModalOrGraphic,
  IGraphicResponse,
  IUpdateParams
} from '@base/@types/providers/Otb/FollowUpProvider'
import { followUpFilter } from '@base/variables/filters/otb/followUpFilter'
import { followUpRequest } from '@base/variables/filters/otb/followUpRequest'
import budgetCommercialHeader from '@base/variables/headers/otb/followUp'
const FollowUpOtbProvider: FC = ({ children }) => {
  const toast = useToast()

  const currentMonth = useMemo(() => new Date().getMonth() + 1, [])
  const currentYear = useMemo(() => new Date().getFullYear(), [])
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useBoolean(true)
  const filtersList: ILayoutFilter[] = followUpFilter

  const [filename, setFilename] = useState('OTB Acompanhamento - Relatório')

  const [data, updateData] = useImmer<any[]>([])
  const [graphicValues, setGraphicValues] = useState({} as IGraphicResponse)
  const [isGraphic, setIsGraphic] = useState(false)
  const [loadingGraphic, setLoadingGraphic] = useState(false)
  const [isShowContentChart, setIsShowContentChart] = useState(false)
  const [_stateLineData, setStateLineData] = useState({} as ILineParams)
  const [dataUpdate, updateDataUpdate] = useImmer<any[]>([])
  const [query, setQuery] = useState('')
  const [hiddenColumns, _updateHiddenColumns] = useImmer<string[]>([])

  const [params, updateParams] = useImmer<any>(() => {
    const paramsFormatted = { ...followUpRequest }

    return paramsFormatted
  })

  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })
  const [headers, updateHeaders] = useImmer<ITableHeader[]>(
    budgetCommercialHeader
  )
  const [paramsToSend, setParamsToSend] = useState<IParamsToSend>(() => {
    const paramsFormatted = { ...followUpRequest }

    return paramsFormatted
  })

  const clearAllFilters = () => {
    const paramsFormatted = { ...followUpRequest }

    const reseteFilters: any = {
      empresaIds: true,
      empresaSelectIds: [],
      categoriasIds: false,
      categoriasSelectIds: [],
      categoriaIds: true,
      categoriaSelectIds: [],
      gerenteCategoriaIds: false,
      gerenteCategoriaSelectIds: [],
      gerenteProdutoIds: false,
      gerenteProdutoSelectIds: [],
      mundoIds: false,
      mundoSelectIds: [],
      produtoIds: false,
      produtoSelectIds: []
    }

    updateParams({
      ...params,
      ...reseteFilters
    })

    setParamsToSend(paramsFormatted)

    if (localStorage.getItem('otbFollowUpParams')) {
      localStorage.setItem(
        'otbFollowUpParams',
        crypto.AES.encrypt(
          JSON.stringify({
            ...params,
            ...reseteFilters
          }),
          'CHAVE'
        ).toString()
      )
    }

    if (localStorage.getItem('@otbFollowUpParamsRequest')) {
      localStorage.setItem(
        '@otbFollowUpParamsRequest',
        crypto.AES.encrypt(JSON.stringify(paramsFormatted), 'CHAVE').toString()
      )
    }
  }

  const handleUpdateParams = ({ name, value }: IUpdateParams) => {
    updateParams((draft: { [x: string]: string }) => {
      draft[name] = value
    })

    const paramsToSendFormatted = paramsFollowUpToSendMapping({
      name,
      compareName: name,
      value: value,
      values: value,
      paramsToSend,
      fieldName: validateGroupName(name)
    })

    setParamsToSend(paramsToSendFormatted)
    if (localStorage.getItem('otbFollowUpParams')) {
      const newParams: IParamsToSend[] = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('otbFollowUpParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )

      localStorage.setItem(
        'otbFollowUpParams',
        crypto.AES.encrypt(
          JSON.stringify({ ...newParams, [name]: value }),
          'CHAVE'
        ).toString()
      )
    }
    if (localStorage.getItem('@otbFollowUpParamsRequest')) {
      localStorage.setItem(
        '@otbFollowUpParamsRequest',
        crypto.AES.encrypt(
          JSON.stringify(paramsToSendFormatted),
          'CHAVE'
        ).toString()
      )
    }
  }

  const handleLocalParams = useCallback(async () => {
    if (localStorage.getItem('otbFollowUpParams')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('otbFollowUpParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      updateParams(newParams)
    } else {
      const paramsFormatted = { ...followUpRequest }
      localStorage.setItem(
        'otbFollowUpParams',
        crypto.AES.encrypt(JSON.stringify(paramsFormatted), 'CHAVE').toString()
      )
      updateParams(paramsFormatted)
    }
    if (localStorage.getItem('@otbFollowUpParamsRequest')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('@otbFollowUpParamsRequest'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      setParamsToSend(newParams)
    } else {
      localStorage.setItem(
        '@otbFollowUpParamsRequest',
        crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
      )
    }
  }, [updateParams, currentYear, currentMonth, paramsToSend])

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      const newHeaders = [...headers]

      newHeaders[index].columns[column] = {
        id: newHeaders[index].columns[column].id,
        name: newHeaders[index].columns[column].name,
        show: !newHeaders[index].columns[column].show,
        notShowColumn: newHeaders[index].columns[column].notShowColumn
          ? !newHeaders[index].columns[column].notShowColumn
          : true
      }

      updateHeaders(newHeaders)
    },
    [headers, updateHeaders]
  )

  const actions = useMemo<ILayoutToolsAction[]>(() => {
    return [
      {
        type: 'export',
        exports: [
          {
            type: 'excel',
            entity: 'otbFollowUp',
            data,
            headers
          }
        ]
      },
      {
        type: 'columns',
        data: headers,
        onToggleColumn: toggleColumn
      }
    ]
  }, [data, headers, toggleColumn])

  const handlePageChange = useCallback(
    async (_page: number) => {
      setLoading(true)

      localStorage.setItem(
        '@OtbFollowUp:',
        crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
      )

      followUp
        .postOtbFollowUp(paramsToSend, _page)
        .then(({ data: { data, pagination } }) => {
          updateData(draft => {
            return draft.filter(item => item.status === 99).concat(data)
          })
          updatePagination(pagination)
          setLoading(false)
        })
        .catch(() => {
          updateData([])
          setLoading(false)
        })
    },
    [paramsToSend, updateData, updatePagination]
  )

  const updateShowTableInTable = useCallback(
    async (data: any[]) => {
      updateData(draft => {
        return draft.filter(item => item.status === 99).concat(data)
      })

      const headersFormatted = validateIfShowColumnInTable(
        headers,
        paramsToSend
      )

      updateHeaders(headersFormatted)
    },
    [updateData, updateHeaders, headers, paramsToSend]
  )
  const getData = useCallback(async () => {
    // await getMaintence()
    const isDisabledProgress = paramsToSend.empresa.ids.length > 0
    if (!isDisabledProgress) {
      toast({
        title: 'Atenção',
        description: 'Selecionar empresa',
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
      return
    }
    setLoading(true)
    let newParams = {}
    if (localStorage.getItem('@otbFollowUpParamsRequest')) {
      newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('@otbFollowUpParamsRequest'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
    } else {
      newParams = paramsToSend
    }
    localStorage.setItem(
      '@otbFollowUpParamsRequest',
      crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
    )
    followUp
      .postOtbFollowUp(newParams, 1)
      .then(({ data: { data, pagination } }) => {
        updateShowTableInTable(data)

        updatePagination(pagination)
        setFilters.toggle()
        setLoading(false)
      })
      .catch(() => {
        updateData([])
        setLoading(false)
      })
  }, [paramsToSend, updateShowTableInTable, updatePagination, updateData])

  // const handlePageChange = useCallback(
  //   async (page: number, paramsToSendFormatted?: IParamsToSend) => {
  //     setLoading(true)
  //     let newParams = {}
  //     if (localStorage.getItem('otbFollowUpParamsRequest')) {
  //       newParams = JSON.parse(
  //         localStorage.getItem('otbFollowUpParamsRequest') || ''
  //       )
  //     } else {
  //       newParams = paramsToSend
  //     }
  //     localStorage.setItem(
  //       '@AlertPurchaseParamsToSend:',
  //       JSON.stringify(paramsToSend)
  //     )
  //     followUp
  //       .postOtbFollowUp(newParams, page)
  //       .then(({ data: { data, pagination } }) => {
  //         updateShowTableInTable(data)

  //         updatePagination(pagination)
  //         setLoading(false)
  //       })
  //       .catch(() => {
  //         updateData([])
  //         setLoading(false)
  //       })
  //   },
  //   [paramsToSend, updateShowTableInTable, updatePagination, updateData]
  // )

  const tableInteraction = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'checkbox',
        icon: <AiOutlineBarChart />,
        isMulti: false
      }
    ]
  }, [])
  const handleUpdateBudgetWanted = useCallback(
    async (index: number, _wanted: number | string) => {
      let commercials = []

      commercials = data
      const commercial = commercials.filter(x => x.id === Number(index))[0]
      try {
        try {
          commercials = [...commercials] // important to create a copy, otherwise you'll modify state outside of setState call
          commercials[index] = {
            ...commercial
          }
          const newData = commercials
          updateData(draft => {
            return draft.filter(item => item.status === 99).concat(newData)
          })
          updateDataUpdate([...dataUpdate, index])
        } catch (e) {}
      } catch {}
    },
    [data, updateData, dataUpdate, updateDataUpdate]
  )

  const handleUpdateGrowthWanted = useCallback(
    async (index: number, wanted: number | string) => {
      // setLoading(true)

      let commercials = []

      commercials = data
      const commercial = commercials.filter(x => x.id === Number(index))[0]
      const idData = commercials.findIndex((x: any) => x.id === Number(index))
      try {
        try {
          commercials = [...commercials] // important to create a copy, otherwise you'll modify state outside of setState call
          commercials[idData] = {
            ...commercial,
            previsaoAnoAtual: wanted,
            alterado: true
          }
          const newData = commercials
          updateData(draft => {
            return draft.filter(item => item.status === 99).concat(newData)
          })
          updateDataUpdate([...dataUpdate, idData])
        } catch (e) {}
      } catch {}
      // setLoading(false)
    },
    [data, updateData, dataUpdate, updateDataUpdate]
  )
  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${column.name}`
          })
        }
      }
    }

    return data
  }, [headers])

  const convertExpCsv = (data: any) => {
    const csvRows = []

    // Headers is basically a keys of an
    // object which is id, name, and
    // profession
    // Pushing Object values into array
    // with comma separation

    const newColumn: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          newColumn.push(`${column.name}`)
        }
      }
    }

    const hd = newColumn

    // As for making csv format, headers
    // must be separated by comma and
    // pushing it into array
    csvRows.push(hd.join(','))
    const parsedData = parseFollowUpOtbData(data)

    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        item[column.id] = row[column.id]
      }

      body.push(item)
    }

    const values = Object.values(body).join(',')
    csvRows.push(values)

    // Returning the array joining with new line
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8' })
    FileSaver.saveAs(blob, 'OTB - Acompanhamento')
  }

  const exportData = useCallback(async () => {
    Swal.fire({
      title: 'Exporta dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 99999,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    let newParams = {}
    if (localStorage.getItem('@otbFollowUpParamsRequest')) {
      newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('@otbFollowUpParamsRequest'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
    } else {
      newParams = paramsToSend
    }
    localStorage.setItem(
      '@otbFollowUpParamsRequest',
      crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
    )
    try {
      await followUp
        .postOtbFollowUpAll(newParams)
        .then(({ data: { data } }) => {
          Swal.close()
          convertExpCsv(data)
          // downloadCsv(rows, columns, 'OTB - Acompanhamento')

          setLoading(false)
        })
        .catch(() => {
          Swal.close()

          setLoading(false)
        })
    } catch (error: any) {
      const { data } = error.response
      Swal.close()
      const message =
        data.response?.status === 400
          ? data.response?.data?.data[0].message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
    }
  }, [paramsToSend, toast, filename, headers])
  const getDataGraphic = useCallback(
    (lineData: ILineParams) => {
      setIsShowContentChart(true)
      const index = lineData['index-index']
      setLoadingGraphic(true)
      setGraphicValues({
        desvioMedio: [
          {
            data: 'ESTQ INICIAL',
            valor: data[index].estoqueInicialEmCusto
          },
          {
            data: 'ESTQ ATUAL',
            valor: data[index].estoqueAtualEmCusto
          },
          // {
          //   data: 'RECEBIDO MÊS',
          //   valor: data[index].recebidos
          // },
          {
            data: 'VD REAL',
            valor: data[index].vendasRealizadasEmCusto
          },

          // {
          //   data: 'A RECEBER',
          //   valor: data[index].recebimentosProgramados
          // },
          {
            data: 'VEND PROJ',
            valor: data[index].vendasProjetadasEmCusto
          },
          // {
          //   data: 'OTB',
          //   valor: data[index].otbPlanejamento
          // },
          {
            data: 'ESTQ PROJ',
            valor: data[index].estoqueProjetadoEmCusto
          },
          {
            data: 'QTD RECEBER',
            valor: data[index].quantidadeAReceberEmCusto
          }
        ]
      })
      setLoadingGraphic(false)
    },
    [data]
  )

  const parseParamsModalOrGraphic = ({
    lineData
  }: IParseParamsModalOrGraphic) => {
    getDataGraphic(lineData)
  }

  const updateIsGraphic = (lineData: ILineParams) => {
    setIsGraphic(true)
    setStateLineData(lineData)

    parseParamsModalOrGraphic({
      isClickLine: true,
      lineData
    })
  }

  return (
    <FollowUpOtbContext.Provider
      value={{
        loading,

        filtersList,
        pagination,
        tableInteraction,
        hiddenColumns,
        data: parseFollowUpOtbData(data),
        dataFooter: parseFollowUpOtbFooterData(data),
        actions,
        params,
        handlePageChange,
        handleUpdateBudgetWanted,
        handleUpdateGrowthWanted,
        headers,
        filename,
        filters,
        query,
        handleLocalParams,
        setFilename,
        exportData,
        setQuery,
        toggleColumn,
        handleUpdateParams,
        getData,
        setFilters,
        clearAllFilters,

        isGraphic,
        graphicValues,
        loadingGraphic,
        isShowContentChart,
        setIsGraphic,
        setGraphicValues,
        setIsShowContentChart,
        setLoadingGraphic,
        updateIsGraphic
      }}
    >
      {children}
    </FollowUpOtbContext.Provider>
  )
}

export default FollowUpOtbProvider
export const FollowUpOtbContext = createContext<IFollowUpOtbContext>(
  {} as IFollowUpOtbContext
)
